import Button from "components/common/Button";
import Dropdown from "components/common/Dropdown";
import TextInput from "components/common/InputField/TextInput";
import PageTitleSection from "components/common/PageTitleSection";
import WorkforceAnalyticsCard from "components/common/WorkforceAnalyticsCard";
import React, { useEffect, useState } from "react";
import GridView from "../TaskManager/GridView";
import ListView from "../TaskManager/ListView";
import { camelCaseToRegularCase } from "helpers/camelCaseToRegularCase";
import moment from "moment";
import ModalContainer from "components/common/ModalContainer";
import SelectInput from "components/common/InputField/SelectInput";
import TextareaInput from "components/common/InputField/TextareaInput";
import { useNavigate } from "react-router-dom";
import useGetAllAgent from "hooks/workforceHooks/useGetAllAgent";
import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import { workforceActions } from "redux/Ldb/actions";
import { debounce, orderBy } from "lodash";
import Skeleton from "react-loading-skeleton";
import { formatMoney, getFromStorage } from "helpers";
import useGetTaskAnalytics from "hooks/workforceHooks/useGetTaskAnalytics";
import { useChannel } from "ably/react";
import useGetTaskList from "hooks/workforceHooks/useGetTaskList";
import { getAgentName } from "helpers/getAgentName";
import SynthTooltip from "components/common/SynthTooltip";
import MultiselectInput from "components/common/InputField/MultiselectInput";
import ToggleInput from "components/common/InputField/ToggleInput";
import { agentTypeRename } from "helpers/renameAgentType";

const NewDesign = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const profile = getFromStorage("ally-user");

    const [selectedView, setSelectedView] = useState<string>("grid");
    const [search, setSearch] = useState<string>("");
    const [requestCustomAI, setRequestCustomAI] = useState<boolean>(false);
    const [activeTasks, setActiveTasks] = useState([]);
    const [pendingTasks, setPendingTasks] = useState([]);
    const [completedTasks, setCompletedTasks] = useState([]);
    const [failedTasks, setFailedTasks] = useState([]);
    const [showOtherInput, setShowOtherInput] = useState<boolean>(false);
    const [filteredList, setFilteredList] = useState<any[]>([]);
    const [refetch, setRefetch] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [isActive, setIsActive] = useState<{
        id?: string;
        isActive?: boolean;
    }>({
        id: "",
        isActive: false,
    });

    const [request, setRequest] = useState<{
        name?: string;
        description: string;
        additionalNote?: string;
        agentData?: string[];
        other?: string;
        agentOutputPurpose?: string;
        agentRunFrequency?: string;
        agentUser?: string[];
        agentPriority?: string;
    }>({
        name: "",
        description: "",
        additionalNote: "",
        agentData: [],
        other: "",
        agentOutputPurpose: "",
        agentRunFrequency: "",
        agentUser: [],
        agentPriority: "",
    });
    const [tasksTotal, setTasksTotal] = useState<{ [key: string]: any }>({
        activeTasks: 0,
        pendingTasks: 0,
        completedTasks: 0,
        failedTasks: 0,
    });
    const { createAgentRequestSuccess, creatingAgentRequest } = useAppSelector(
        (state) => state?.workforce
    );
    const { data: taskAnalytics, isFetching: isFetchingAnalytics } = useGetTaskAnalytics();

    const {
        data: allAgentList,
        isFetching: fetchingAllAgents,
        setDebouncedSearch,
        setType,
        type,
    } = useGetAllAgent({
        refetch,
    });

    const filterOptions = [
        {
            name: "All",
            value: "",
        },
        {
            name: "Active",
            value: "active",
        },
        {
            name: "Order Processing",
            value: "orderProcessing",
        },
        {
            name: "Sales & Marketing",
            value: "marketingCampaign",
        },
        {
            name: "Inventory",
            value: "InventoryManagement",
        },
        {
            name: "Custom",
            value: "custom",
        },
    ];

    const {
        data: tasks,
        search: searchTask,
        handleSearch,
        handleDebouncedChange,
        handleTaskStatusChange,
        handleClearTaskStatusFilter,
        handleTaskTypeChange,
        handleClearTaskTypeFilter,
        taskStatus,
        taskType,
        pagination,
        setUpdatedPage,
        setLoadMore,
    } = useGetTaskList();

    const { updateAgentStatusSuccess, updatingAgentStatus } = useAppSelector(
        (state) => state?.workforce
    );

    const handleUpdateAgentStatus = (agentId: string, isActive: boolean) => {
        dispatch(workforceActions.updateAgentStatus(agentId, { isActive }));
    };

    useEffect(() => {
        if (Boolean(updateAgentStatusSuccess)) {
            dispatch(workforceActions.resetUpdateAgentStatusSuccess());
            setUpdating(true);
            setRefetch(!refetch);
        }
    }, [dispatch, updateAgentStatusSuccess]);

    useEffect(() => {
        // if (allAgentList?.length > 0) {
        setFilteredList(allAgentList?.length > 0 ? allAgentList : []);
        // setFilteredList(
        //     allAgentList?.filter(
        //         (item) =>
        //             item?.type !== "ProductForecast" &&
        //             item?.type !== "TargetAlly" &&
        //             item?.type !== "InventoryManagement"
        //     )
        // );
        // }
        setIsActive({
            id: "",
            isActive: false,
        });
    }, [allAgentList]);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const agentData = request?.agentData?.filter((item) => item !== "Other");
        const body = {
            ...(request.name && { name: request.name }),
            description: request?.description,
            ...(request?.additionalNote && { additionalNote: request?.additionalNote }),
            ...(agentData?.length > 0 && { agentData: agentData }),
            ...(request?.other && { other: request?.other }),
            ...(request?.agentOutputPurpose && { agentOutputPurpose: request?.agentOutputPurpose }),
            ...(request?.agentRunFrequency && {
                agentRunFrequency: request?.agentRunFrequency,
            }),
            ...(request?.agentUser?.length > 0 && { agentUser: request?.agentUser }),
            ...(request?.agentPriority && { agentPriority: request?.agentPriority }),
        };
        dispatch(workforceActions.createAgentRequest(body));
    };

    useEffect(() => {
        if (createAgentRequestSuccess) {
            dispatch(workforceActions.resetCreateAgentRequestSuccess());
            setRequest({
                name: "",
                description: "",
                additionalNote: "",
                agentData: [],
                other: "",
                agentOutputPurpose: "",
                agentRunFrequency: "",
                agentUser: [],
                agentPriority: "",
            });
            setRequestCustomAI(false);
        }
    }, [dispatch, createAgentRequestSuccess]);

    const getOtherDetails = (agent: any) => {
        switch (agent) {
            case "orderProcessing":
                return {
                    name: "Email Order Processing",
                    text: "Turns messy email orders into clean data automatically.",
                    img: "https://storage.googleapis.com/heysynth_files/synth_webapp/Frame%202085661197%20(7).svg",
                    icons: [
                        "https://storage.googleapis.com/heysynth_files/synth_webapp/gmail_1_zya4ai.svg",
                        "https://storage.googleapis.com/heysynth_files/synth_webapp/ms_outlook_iqonc9.svg",
                    ],
                    active: true,
                    color: "#6562E5",
                };
            case "marketingCampaign":
                return {
                    name: "Marketing Campaign",
                    text: "Syncs promotions with real-time inventory levels.",
                    icons: [
                        "https://storage.googleapis.com/heysynth_files/synth_webapp/Klaviyo_symbol_zynlc7.webp",
                        "https://storage.googleapis.com/heysynth_files/synth_webapp/tiktok_logo.webp",
                        "https://storage.googleapis.com/heysynth_files/synth_webapp/google-ads_syiiti.svg",
                    ],
                    img: "https://storage.googleapis.com/heysynth_files/synth_webapp/Frame%202085661197%20(8).svg",
                    color: "#EA580C",
                };
            case "EDIAssistant":
                return {
                    name: "EDI Assistant",
                    text: "Automates EDI document processing workflows.",
                    icons: [
                        "https://storage.googleapis.com/heysynth_files/synth_webapp/sps_commerce_v0uhiz.png",
                    ],
                    img: "https://storage.googleapis.com/heysynth_files/synth_webapp/Frame%202085661197%20(9).svg",
                    color: "#00C6FA",
                };
            case "InventoryManagement":
                return {
                    name: "Inventory Report Agent",
                    text: "Automatically updates inventory reports from 3PLs, warehouses, and manufacturers.",
                    img: "https://storage.googleapis.com/heysynth_files/synth_webapp/Frame%202085661197%20(15).svg",
                    color: "#B9017A",
                };
            case "TargetAlly":
                return {
                    name: "Target Ally",
                    text: "Set and track sales target and performance using natural language prompts",
                    img: "https://storage.googleapis.com/heysynth_files/synth_webapp/Frame%202085661197%20(13).svg",
                    color: "#56B648",
                    canTurnOffAgent: true,
                };
            case "NewProductForecaster":
                return {
                    name: "New Product Forecaster",
                    text: "Generate forecasts for new product launches using existing product and channel data",
                    img: "https://storage.googleapis.com/heysynth_files/synth_webapp/Frame%202085661197%20(14).svg",
                    color: "#0054C2",
                    canTurnOffAgent: true,
                };
            case "stockSense":
                return {
                    name: "StockSense",
                    text: "Tracks, forecasts and automates store-level inventory workflows.",
                    img: "https://storage.googleapis.com/heysynth_files/synth_webapp/Frame%202085661197%20(10).svg",
                    color: "#FFB902",
                };
            case "custom":
                return {
                    name: "Request Custom AI Agent",
                    text: "Can't find what you need? We'll create a custom agent that fits your requirements.",
                    status: "custom",
                    img: "https://storage.googleapis.com/heysynth_files/synth_webapp/Frame%202085661197%20(11).svg",
                    // color: "#FFB902",
                };
            default:
                return {
                    name: camelCaseToRegularCase(agent),
                    text: "",
                    status: "",
                    img: "https://storage.googleapis.com/heysynth_files/synth_webapp/Frame%202085661197%20(9).svg",
                };
        }
    };
    const {} = useChannel(
        `agent_tasks_${profile?.user?.parentId || profile?.user?._id}`,
        (taskData) => {
            const isTask = taskData?.name?.split("_")?.length === 2;

            if (isTask) {
                let activeTasksCopy = [...activeTasks];
                let pendingTasksCopy = [...pendingTasks];
                let completedTasksCopy = [...completedTasks];
                let failedTasksCopy = [...failedTasks];

                const activeTaskIndex = activeTasksCopy?.findIndex(
                    (task) => task?._id === taskData?.data?.task?._id
                );
                const pendingTaskIndex = pendingTasksCopy?.findIndex(
                    (task) => task?._id === taskData?.data?.task?._id
                );
                const completedTaskIndex = pendingTasksCopy?.findIndex(
                    (task) => task?._id === taskData?.data?.task?._id
                );
                const failedTaskIndex = failedTasksCopy?.findIndex(
                    (task) => task?._id === taskData?.data?.task?._id
                );

                const moveToPending =
                    taskData?.data?.task?.status?.toLowerCase() === "pending" ||
                    taskData?.data?.task?.status?.toLowerCase() === "attention required";
                const moveToActive = taskData?.data?.task?.status?.toLowerCase() === "in progress";
                const moveToCompleted = taskData?.data?.task?.status?.toLowerCase() === "completed";
                const moveToFailed = taskData?.data?.task?.status?.toLowerCase() === "failed";

                if (activeTaskIndex !== -1) {
                    activeTasksCopy?.splice(activeTaskIndex, 1);
                }

                if (pendingTaskIndex !== -1) {
                    pendingTasksCopy?.splice(pendingTaskIndex, 1);
                }

                if (completedTaskIndex !== -1) {
                    completedTasksCopy?.splice(completedTaskIndex, 1);
                }

                if (failedTaskIndex !== -1) {
                    failedTasksCopy?.splice(failedTaskIndex, 1);
                }

                if (moveToPending) {
                    pendingTasksCopy = [taskData?.data?.task, ...pendingTasksCopy];
                }
                if (moveToActive) {
                    activeTasksCopy = [taskData?.data?.task, ...activeTasksCopy];
                }
                if (moveToCompleted) {
                    completedTasksCopy = [taskData?.data?.task, ...completedTasksCopy];
                }
                if (moveToFailed) {
                    failedTasksCopy = [taskData?.data?.task, ...failedTasksCopy];
                }

                setPendingTasks(orderBy(pendingTasksCopy, "createdAt", ["desc"]));
                setActiveTasks(orderBy(activeTasksCopy, "createdAt", ["desc"]));
                setCompletedTasks(orderBy(completedTasksCopy, "createdAt", ["desc"]));
                setFailedTasks(orderBy(failedTasksCopy, "createdAt", ["desc"]));
            }
        }
    );

    useEffect(() => {
        setActiveTasks(orderBy(tasks?.activeTasks, "createdAt", ["desc"]));
        setPendingTasks(orderBy(tasks?.pendingTasks, "createdAt", ["desc"]));
        setCompletedTasks(orderBy(tasks?.completedTasks, "createdAt", ["desc"]));
        setFailedTasks(orderBy(tasks?.failedTasks, "createdAt", ["desc"]));
        setTasksTotal({
            activeTasks: tasks?.totalActiveTasks,
            pendingTasks: tasks?.totalPendingTasks,
            completedTasks: tasks?.totalCompletedTasks,
            failedTasks: tasks?.totalFailedTasks,
        });
    }, [tasks]);
    return (
        <div>
            <div className="p-4 border border-slate-100 rounded-[8px] bg-white">
                <div className="mb-6">
                    <PageTitleSection
                        leftComp={
                            <div className="flex items-center space-x-3">
                                <h3 className="text-xl font-rocGroteskMedium">WorkforceIQ</h3>
                            </div>
                        }
                    />
                </div>

                <div
                    className={`bg-gradient-to-b from-[#BCF4CD] via-[#E7FBBE] to-[#FFFDF8]  ${
                        selectedView === "list" ? "to-80%" : "to-70%"
                    } rounded-lg p-6 relative`}
                >
                    <div className="absolute top-0 left-0 z-0">
                        <img
                            src="https://storage.googleapis.com/heysynth_files/synth_webapp/Vector%20(7).svg"
                            alt=""
                            className="w-full h-full"
                        />
                    </div>
                    <div className="relative z-10">
                        <p className="text-g-75 text-[32px] font-rocGroteskMedium my-2">
                            Find, Create and Customize AI Agents for Back-Office Ops
                        </p>

                        <div className="flex items-center justify-between flex-wrap gap-2">
                            <div className="flex items-center gap-2 my-4 flex-wrap">
                                {filterOptions?.map((item, idx) => (
                                    <p
                                        key={idx}
                                        className={`${
                                            type === item?.value
                                                ? "text-white bg-g-75"
                                                : "bg-white text-g-75"
                                        }  font-rocGroteskMedium text-base py-2.5 px-4 shadow-[0px_4px_12px_0px_rgba(0,0,0,0.10)] rounded-[30px] cursor-pointer`}
                                        onClick={() => {
                                            setType(item?.value);
                                            setUpdating(false);
                                            // if (item?.value === "custom") {
                                            //     setRequestCustomAI(true);
                                            // }
                                        }}
                                    >
                                        {item?.name}
                                    </p>
                                ))}
                            </div>

                            <div className="shadow-[0px_4px_12px_0px_rgba(0,0,0,0.10)] rounded-[30px]">
                                <TextInput
                                    name="search"
                                    type="text"
                                    value={search}
                                    onChange={(e) => setSearch(e?.target?.value)}
                                    onInput={debounce((e: any) => {
                                        setDebouncedSearch(e?.target?.value);
                                    }, 800)}
                                    inputPlaceholder={"Search for AI Agents"}
                                    inputClassName={
                                        "!h-[38px] pl-[0px] !mb-0 !font-rocGroteskMedium !text-slate-500"
                                    }
                                    leftIcon={
                                        <i className="ri-search-line before:content-['\f0d1] text-slate-500 mt-[2px]"></i>
                                    }
                                    inputContainerClassname={` !rounded-[30px]  !h-[40px] !pl-[20px] !bg-white !border !border-slate-200`}
                                    containerClassname={"!w-[418px]"}
                                />
                            </div>
                        </div>
                        {fetchingAllAgents && !search && type === "" && !updating ? (
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-[30px] mb-8">
                                {[1, 1, 1, 1, 1, 1]?.map((_, idx) => (
                                    <Skeleton
                                        key={idx}
                                        width={"100%"}
                                        height={396}
                                        highlightColor="#E2E8F0"
                                        borderRadius={8}
                                        baseColor="#F1F5F9"
                                        className="custom-skeleton rounded-xl"
                                    />
                                ))}
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3  2xl:grid-cols-4 gap-[30px] font-rocGroteskMedium mt-8">
                                {filteredList?.map((agent, idx) => {
                                    const otherDetails = getOtherDetails(agent?.type);
                                    return (
                                        otherDetails && (
                                            <div
                                                className="cursor-pointer max-w-[396px] shadow-[0px_4px_8px_-4px_rgba(16,24,40,0.12),0px_20px_24px_-4px_rgba(16,24,40,0.08)] rounded-xl bg-white"
                                                key={idx}
                                                onClick={() => {
                                                    if (otherDetails?.canTurnOffAgent) {
                                                        navigate(
                                                            `/dashboard/forecast?agent=${agent?.type}`,
                                                            {
                                                                state: {
                                                                    internalNavigation: true,
                                                                },
                                                            }
                                                        );
                                                    } else {
                                                        if (agent?.activeAgent?.createdAt) {
                                                            navigate(
                                                                `/dashboard/workforce/ai-teammate/${agent?.activeAgent?._id}/${agent?._id}?currTab=1`,
                                                                {
                                                                    state: {
                                                                        internalNavigation: true,
                                                                    },
                                                                }
                                                            );
                                                        } else {
                                                            navigate(
                                                                `/dashboard/workforce/ai-teammate/non-active/${agent?._id}`,
                                                                {
                                                                    state: {
                                                                        internalNavigation: true,
                                                                    },
                                                                }
                                                            );
                                                        }
                                                    }
                                                }}
                                            >
                                                <div className="relative">
                                                    {/* agent?.activeAgent?.createdAt */}
                                                    {agent?.activeAgent?.isActive && (
                                                        <p className="absolute top-5 right-4 !rounded !py-0.5 !px-2 !bg-[#F2FFF7] !text-[#16A34A] !w-fit">
                                                            {" "}
                                                            Active
                                                        </p>
                                                    )}
                                                    <img
                                                        src={otherDetails?.img}
                                                        alt={otherDetails?.name}
                                                        className="w-full max-h-[250px] object-cover rounded-t-xl"
                                                        style={{
                                                            backgroundColor: otherDetails?.color,
                                                            height: "250px",
                                                        }}
                                                    />
                                                </div>
                                                <div className="bg-white rounded-b-xl py-4 px-5 text-sm min-h-[230px] flex flex-col justify-between">
                                                    <div>
                                                        <div className="flex items-center justify-between">
                                                            <div className="flex items-center gap-2">
                                                                <div
                                                                    className="w-5 h-5 rounded-full flex items-center justify-center"
                                                                    style={{
                                                                        backgroundColor:
                                                                            otherDetails?.color,
                                                                    }}
                                                                >
                                                                    <i className="ri-robot-fill text-white text-sm"></i>
                                                                </div>
                                                                <p className="text-base text-g-75">
                                                                    {otherDetails?.name}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        {(!agent?.activeAgent?.createdAt ||
                                                            otherDetails?.canTurnOffAgent) && (
                                                            <p className="text-slate-500">
                                                                {otherDetails?.text}
                                                            </p>
                                                        )}
                                                        {agent?.activeAgent?.createdAt &&
                                                            !otherDetails?.canTurnOffAgent && (
                                                                <div className="text-slate-500 ">
                                                                    <div className="">
                                                                        <p className="">
                                                                            Created on:{" "}
                                                                            {moment(
                                                                                agent?.activeAgent
                                                                                    ?.createdAt
                                                                            )?.format(
                                                                                "MMM DD, YYYY"
                                                                            )}
                                                                        </p>
                                                                        <p className="">
                                                                            {agent?.onGoingTasks ??
                                                                                0}{" "}
                                                                            ongoing tasks
                                                                        </p>
                                                                    </div>
                                                                    <div className="flex border border-slate-200 rounded-md mt-4">
                                                                        <div className="py-2.5 px-4 flex-1 border-r border-r-slate-200">
                                                                            <p className="">
                                                                                Total savings
                                                                            </p>
                                                                            <p className="text-g-75">
                                                                                $
                                                                                {formatMoney().format(
                                                                                    agent?.totalCostSaved
                                                                                ) || 0}
                                                                            </p>
                                                                        </div>

                                                                        <div className="py-2.5 px-4 flex-1">
                                                                            <p className="">
                                                                                Time saved
                                                                            </p>
                                                                            <p className="text-g-75">
                                                                                {agent?.totalTimeSaved ??
                                                                                    0}{" "}
                                                                                {agent?.totalTimeSaved >
                                                                                1
                                                                                    ? "hours"
                                                                                    : "hour"}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                    </div>
                                                    <div
                                                        className={`flex ${
                                                            otherDetails?.status === "custom" ||
                                                            otherDetails?.canTurnOffAgent
                                                                ? "justify-start"
                                                                : otherDetails?.icons?.length > 0
                                                                ? "justify-between"
                                                                : "justify-end"
                                                        } mt-4`}
                                                    >
                                                        <div className="flex items-center gap-2 ">
                                                            {otherDetails?.icons?.map((icon) => (
                                                                <img
                                                                    src={icon}
                                                                    alt={icon}
                                                                    width={32}
                                                                    height={32}
                                                                    className="w-6 h-6 p-1 border border-slate-200 rounded-full"
                                                                />
                                                            ))}
                                                        </div>

                                                        {agent?.activeAgent?.createdAt &&
                                                        !otherDetails?.canTurnOffAgent ? (
                                                            <Button
                                                                btnClassname={`!rounded !py-1.5 !px-3 !text-white !w-fit `}
                                                                style={{
                                                                    backgroundColor:
                                                                        otherDetails?.color ??
                                                                        "#6562E5",
                                                                }}
                                                                btnText="View more info"
                                                                onClick={() => {
                                                                    navigate(
                                                                        `/dashboard/workforce/ai-teammate/${agent?.activeAgent?._id}/${agent?._id}?currTab=1`,
                                                                        {
                                                                            state: {
                                                                                internalNavigation:
                                                                                    true,
                                                                            },
                                                                        }
                                                                    );
                                                                }}
                                                            />
                                                        ) : otherDetails?.canTurnOffAgent ? (
                                                            <div
                                                                className={`flex items-center gap-1 mt-4`}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                }}
                                                            >
                                                                <ToggleInput
                                                                    checked={
                                                                        isActive?.id === agent?._id
                                                                            ? isActive?.isActive
                                                                            : agent?.activeAgent
                                                                                  ?.isActive
                                                                    }
                                                                    name={"isActive"}
                                                                    onChange={(e) => {
                                                                        handleUpdateAgentStatus(
                                                                            agent?._id,
                                                                            e.target.checked
                                                                        );
                                                                        setIsActive({
                                                                            id: agent?._id,
                                                                            isActive:
                                                                                e.target.checked,
                                                                        });
                                                                    }}
                                                                    className="before:!h-4 before:!w-4 h-5 w-[30px] before:left-[2px] rounded-[30px] s-slider"
                                                                />{" "}
                                                                <p className="text-slate-800 -mt-1 text-[13px] font-rocGroteskMedium">
                                                                    Turn{" "}
                                                                    {agent?.activeAgent?.isActive
                                                                        ? "off"
                                                                        : "on"}{" "}
                                                                    agent
                                                                </p>
                                                            </div>
                                                        ) : (
                                                            otherDetails?.status !== "custom" && (
                                                                <Button
                                                                    btnClassname="!rounded !py-1.5 !px-3 !bg-n-20 !text-gm-50 !w-fit"
                                                                    btnText="Setup"
                                                                    onClick={() => {
                                                                        navigate(
                                                                            `/dashboard/workforce/ai-teammate/non-active/${agent?._id}`,
                                                                            {
                                                                                state: {
                                                                                    internalNavigation:
                                                                                        true,
                                                                                },
                                                                            }
                                                                        );
                                                                    }}
                                                                />
                                                            )
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    );
                                })}
                                {((!type && !search) ||
                                    type === "custom" ||
                                    search?.includes("custom")) &&
                                    [1]?.map((_, idx) => {
                                        const otherDetails = getOtherDetails("custom");

                                        return (
                                            <div
                                                className="max-w-[396px] cursor-pointer"
                                                key={idx}
                                                onClick={() => {
                                                    setRequestCustomAI(true);
                                                }}
                                            >
                                                <img
                                                    src={otherDetails?.img}
                                                    alt={otherDetails?.name}
                                                    className="w-full h-auto rounded-t-xl max-h-[250px] object-cover"
                                                    style={{
                                                        backgroundColor: otherDetails?.color,
                                                        height: "250px",
                                                    }}
                                                />
                                                <div className="bg-white rounded-b-xl py-4 px-5 text-sm min-h-[230px] flex flex-col justify-between">
                                                    <div>
                                                        <p className="text-base text-g-75">
                                                            {otherDetails?.name}
                                                        </p>

                                                        <p className="text-slate-500">
                                                            {otherDetails?.text}
                                                        </p>
                                                    </div>
                                                    <Button
                                                        btnClassname="!rounded !py-1.5 !px-3 !bg-n-20 !text-gm-50 !w-fit"
                                                        btnText="Request"
                                                        onClick={() => {
                                                            setRequestCustomAI(true);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        )}

                        <div className="mt-16">
                            <p className="text-g-75 text-[32px] font-rocGroteskMedium mb-6">
                                All Agents Activity
                            </p>
                            {isFetchingAnalytics ? (
                                <div className="grid grid-cols-4 items-center space-x-3 w-full mb-8">
                                    {[1, 2, 3, 4]?.map((_, idx) => (
                                        <Skeleton
                                            key={idx}
                                            width={"100%"}
                                            height={127}
                                            highlightColor="#E2E8F0"
                                            borderRadius={8}
                                            baseColor="#F1F5F9"
                                            className="custom-skeleton"
                                        />
                                    ))}
                                </div>
                            ) : (
                                <div className="grid grid-cols-4 gap-3 mb-[43px]">
                                    <WorkforceAnalyticsCard
                                        title="Total tasks processed"
                                        value={formatMoney().format(
                                            taskAnalytics?.allTasks?.current
                                        )}
                                        containerClassname="!bg-[#FFFF] rounded-lg"
                                        tooltip={
                                            <SynthTooltip
                                                divId={"total-tasks-processed"}
                                                position={"top"}
                                                icon={
                                                    <i className="ri-information-fill text-slate-300 text-sm"></i>
                                                }
                                                contentIcon={<></>}
                                                title="Total tasks processed"
                                                content="Total number of tasks initiated and handled by all AI Agents, including completed, failed, and pending tasks."
                                                styling={{
                                                    width: "270px",
                                                    background: "#142837",
                                                    borderRadius: "6px",
                                                }}
                                                contentClass="text-xs opacity-50"
                                            />
                                        }
                                    />
                                    <WorkforceAnalyticsCard
                                        title="Total tasks completed"
                                        value={formatMoney().format(
                                            taskAnalytics?.totalCompletedTasks ?? 0
                                        )}
                                        containerClassname="!bg-[#FFFF] rounded-lg"
                                        tooltip={
                                            <SynthTooltip
                                                divId={"total-tasks-completed"}
                                                position={"top"}
                                                icon={
                                                    <i className="ri-information-fill text-slate-300 text-sm"></i>
                                                }
                                                contentIcon={<></>}
                                                title="Total tasks completed"
                                                content="The number of tasks successfully executed by all AI Agents with or without manual intervention."
                                                styling={{
                                                    width: "270px",
                                                    background: "#142837",
                                                    borderRadius: "6px",
                                                }}
                                                contentClass="text-xs opacity-50"
                                            />
                                        }
                                    />
                                    <WorkforceAnalyticsCard
                                        title="Total pending tasks"
                                        value={formatMoney().format(
                                            taskAnalytics?.ongoingAiAgentTasks?.current ?? 0
                                        )}
                                        containerClassname="!bg-[#FFFF] rounded-lg"
                                        tooltip={
                                            <SynthTooltip
                                                divId={"total-pending-tasks"}
                                                position={"top"}
                                                icon={
                                                    <i className="ri-information-fill text-slate-300 text-sm"></i>
                                                }
                                                contentIcon={<></>}
                                                title="Total pending tasks"
                                                content="Tasks that have been assigned to AI Agents but are yet to be completed. Some may require human input or approval."
                                                styling={{
                                                    width: "270px",
                                                    background: "#142837",
                                                    borderRadius: "6px",
                                                }}
                                                contentClass="text-xs opacity-50"
                                            />
                                        }
                                    />
                                    <WorkforceAnalyticsCard
                                        title="All agent tasks needing approval"
                                        value={formatMoney().format(
                                            taskAnalytics?.taskRequiringHumanAttention?.current
                                        )}
                                        containerClassname="!bg-[#FFFF] rounded-lg"
                                        tooltip={
                                            <SynthTooltip
                                                divId={"all-agent-tasks-needing-approval"}
                                                position={"top"}
                                                icon={
                                                    <i className="ri-information-fill text-slate-300 text-sm"></i>
                                                }
                                                contentIcon={<></>}
                                                title="All agent tasks needing approval"
                                                content="Tasks that require a human decision or manual confirmation before the AI Agent can proceed."
                                                styling={{
                                                    width: "270px",
                                                    background: "#142837",
                                                    borderRadius: "6px",
                                                }}
                                                contentClass="text-xs opacity-50"
                                            />
                                        }
                                    />
                                    <WorkforceAnalyticsCard
                                        title="Total failed"
                                        value={formatMoney().format(
                                            taskAnalytics?.totalFailedTasks ?? 0
                                        )}
                                        containerClassname="!bg-[#FFFF] rounded-lg"
                                        tooltip={
                                            <SynthTooltip
                                                divId={"total-failed"}
                                                position={"top"}
                                                icon={
                                                    <i className="ri-information-fill text-slate-300 text-sm"></i>
                                                }
                                                contentIcon={<></>}
                                                title="Total failed"
                                                content="The total number of tasks that could not be completed due to errors, missing data, or configuration issues."
                                                styling={{
                                                    width: "270px",
                                                    background: "#142837",
                                                    borderRadius: "6px",
                                                }}
                                                contentClass="text-xs opacity-50"
                                            />
                                        }
                                    />

                                    <WorkforceAnalyticsCard
                                        title="Efficiency ratio"
                                        value={`${
                                            taskAnalytics?.totalEfficiency
                                                ? `${formatMoney().format(
                                                      taskAnalytics?.totalEfficiency
                                                  )} %`
                                                : "0 %"
                                        }`}
                                        containerClassname="!bg-[#FFFF] rounded-lg"
                                        bottomComp={
                                            Boolean(taskAnalytics?.efficiencyGrowth) && (
                                                <div className="flex items-center space-x-2">
                                                    <div
                                                        className={`${
                                                            String(
                                                                taskAnalytics?.efficiencyGrowth
                                                            )?.startsWith("-")
                                                                ? "text-r-55 bg-r-25"
                                                                : "bg-[#F0FDF4] text-[#22C55E]"
                                                        } text-sm px-1.5 py-[2px] flex items-center space-x-1 rounded-[3px] w-fit h-6`}
                                                    >
                                                        <i className="ri-arrow-up-line mt-[-2px] "></i>
                                                        <span>
                                                            {formatMoney().format(
                                                                taskAnalytics?.efficiencyGrowth
                                                            )}
                                                            %
                                                        </span>
                                                    </div>
                                                    <span className="text-sm text-slate-500">
                                                        since last month
                                                    </span>
                                                </div>
                                            )
                                        }
                                        tooltip={
                                            <SynthTooltip
                                                divId={"efficiency-ratio"}
                                                position={"top"}
                                                icon={
                                                    <i className="ri-information-fill text-slate-300 text-sm"></i>
                                                }
                                                contentIcon={<></>}
                                                title="Efficiency ratio"
                                                content="The percentage of tasks completed successfully out of the total processed, measuring overall agent performance."
                                                styling={{
                                                    width: "270px",
                                                    background: "#142837",
                                                    borderRadius: "6px",
                                                }}
                                                contentClass="text-xs opacity-50"
                                            />
                                        }
                                    />
                                    <WorkforceAnalyticsCard
                                        title="Total cost saved by all AI Agents"
                                        value={`$${formatMoney().format(
                                            taskAnalytics?.totalCostSaved
                                        )}`}
                                        containerClassname="!bg-[#FFFF] rounded-lg"
                                        tooltip={
                                            <SynthTooltip
                                                divId={"total-cost-saved-by-all-ai-agents"}
                                                position={"top"}
                                                icon={
                                                    <i className="ri-information-fill text-slate-300 text-sm"></i>
                                                }
                                                contentIcon={<></>}
                                                title="Total cost saved by all AI Agents"
                                                content="The total estimated cost savings generated by all AI Agents."
                                                styling={{
                                                    width: "270px",
                                                    background: "#142837",
                                                    borderRadius: "6px",
                                                }}
                                                contentClass="text-xs opacity-50"
                                            />
                                        }
                                    />
                                    <WorkforceAnalyticsCard
                                        title="Time saved"
                                        value={`${taskAnalytics?.totalTimeSaved ?? 0} hour(s)`}
                                        containerClassname="!bg-[#FFFF] rounded-lg"
                                        tooltip={
                                            <SynthTooltip
                                                divId={"time-saved"}
                                                position={"top"}
                                                icon={
                                                    <i className="ri-information-fill text-slate-300 text-sm"></i>
                                                }
                                                contentIcon={<></>}
                                                title="Time saved"
                                                content="Total hours saved by offloading tasks to AI Agents, freeing up your team."
                                                styling={{
                                                    width: "270px",
                                                    background: "#142837",
                                                    borderRadius: "6px",
                                                }}
                                                contentClass="text-xs opacity-50"
                                            />
                                        }
                                    />
                                </div>
                            )}
                        </div>

                        <div className=" mt-10">
                            <div className="flex justify-between mb-6">
                                <p className="text-g-75 text-[32px] font-rocGroteskMedium">
                                    All Tasks
                                </p>

                                <div className="flex items-center space-x-2 mb-6 max-sm:grid max-sm:space-x-0 max-sm:space-y-2 max-sm:grid-cols-1">
                                    <div className="rounded flex h-[40px] w-[80px] border border-slate-200">
                                        <span
                                            onClick={() => {
                                                setSelectedView("grid");
                                            }}
                                            className={`h-full w-full flex items-center justify-center hover:bg-slate-200 cursor-pointer border-r border-slate-200 ${
                                                selectedView === "grid" && "bg-slate-200"
                                            }`}
                                        >
                                            <i className="ri-layout-grid-line text-base"></i>
                                        </span>
                                        <span
                                            onClick={() => {
                                                setSelectedView("list");
                                            }}
                                            className={`h-full w-full flex items-center justify-center hover:bg-slate-200 cursor-pointer ${
                                                selectedView === "list" && "bg-slate-200"
                                            }`}
                                        >
                                            <i className="ri-list-check text-base"></i>
                                        </span>
                                    </div>

                                    <TextInput
                                        name={"search"}
                                        value={searchTask}
                                        type={"text"}
                                        inputPlaceholder={"Search tasks"}
                                        inputClassName={
                                            "!h-[38px] pl-[0px] !bg-white text-sm !mb-0"
                                        }
                                        onChange={(e) => handleSearch(e)}
                                        onInput={handleDebouncedChange}
                                        containerClassname={"!w-[250px] max-sm:!w-full"}
                                        leftIcon={
                                            <i className="ri-search-line before:content-['\f0d1] text-slate-400 mt-[2px]"></i>
                                        }
                                        inputContainerClassname={
                                            "!rounded-[4px] max-sm:!w-full !pl-[25px] !h-[40px] !bg-white !border !border-slate-200"
                                        }
                                    />

                                    <Dropdown
                                        name="filter"
                                        value={""}
                                        dropdownTriggerClassName={" "}
                                        handleChange={(name, value) => {
                                            handleTaskTypeChange(value);
                                        }}
                                        dropdown={
                                            <div className="bg-white flex items-center max-sm:justify-between h-10 gap-2 py-2.5 px-3 shadow-boxShadow-2 border border-slate-200 !rounded">
                                                <span className="text-[13px] text-slate-500 whitespace-nowrap font-rocGroteskMedium">
                                                    Filter by:
                                                </span>
                                                <span className="text-[13px] whitespace-nowrap font-rocGroteskMedium">
                                                    {taskType
                                                        ? camelCaseToRegularCase(taskType)
                                                        : "All AI Agents"}
                                                </span>

                                                <div className="flex items-center space-x-2">
                                                    {taskType && (
                                                        <i
                                                            onClick={(e) => {
                                                                e?.stopPropagation();
                                                                handleClearTaskTypeFilter();
                                                            }}
                                                            className="ri-close-circle-fill text-sm text-slate-500"
                                                        ></i>
                                                    )}
                                                    <i className="ri-arrow-down-s-line text-lg text-gm-50"></i>
                                                </div>
                                            </div>
                                        }
                                        dropdownClassName={"!w-full !mb-10 !-mt-7"}
                                        dropdownContainerClasses={`shadow-cardShadow-4 !right-0 !mt-0  !w-[159px] max-sm:!w-full  rounded !max-h-fit !p-0 !top-[105%]`}
                                        wholeContainerClass={`max-sm:!w-full`}
                                        dropdownItemsClasses="!bg-transparent"
                                        dropdownOptions={filteredList?.map((agent) => {
                                            return {
                                                label: agentTypeRename(agent?.type),
                                                value: agent?.type,
                                                icon: (
                                                    <i
                                                        className={`ri-sparkling-fill text-base text-[${
                                                            agent?.type === "orderProcessing"
                                                                ? "#6562E5"
                                                                : agent?.type ===
                                                                  "marketingCampaign"
                                                                ? "#FF4F01"
                                                                : agent?.type === "EDIAssistant"
                                                                ? "#00C6FA"
                                                                : agent?.type ===
                                                                  "InventoryManagement"
                                                                ? "#FFB902"
                                                                : "#6562E5"
                                                        }]`}
                                                    ></i>
                                                ),
                                            };
                                        })}
                                    />

                                    <Dropdown
                                        name="filter"
                                        value={""}
                                        dropdownTriggerClassName={" "}
                                        handleChange={(name, value) => {
                                            handleTaskStatusChange(value);
                                        }}
                                        dropdown={
                                            <div className="bg-white flex items-center max-sm:justify-between h-10 gap-2 py-2.5 px-3 shadow-boxShadow-2 border border-slate-200 !rounded">
                                                <span className="text-[13px] text-slate-500 whitespace-nowrap font-rocGroteskMedium">
                                                    Status:
                                                </span>
                                                <span className="text-[13px] whitespace-nowrap font-rocGroteskMedium capitalize">
                                                    {taskStatus || "Status"}
                                                </span>

                                                <div className="flex items-center space-x-2">
                                                    {taskStatus && (
                                                        <i
                                                            onClick={(e) => {
                                                                e?.stopPropagation();

                                                                handleClearTaskStatusFilter();
                                                            }}
                                                            className="ri-close-circle-fill text-sm text-slate-500"
                                                        ></i>
                                                    )}
                                                    <i className="ri-arrow-down-s-line text-lg text-gm-50"></i>
                                                </div>
                                            </div>
                                        }
                                        dropdownClassName={"!w-full !mb-10 !-mt-7"}
                                        dropdownContainerClasses={`shadow-cardShadow-4 !right-0 !mt-0  !w-[159px] max-sm:!w-full  rounded !max-h-fit !p-0 !top-[105%]`}
                                        wholeContainerClass={`max-sm:!w-full`}
                                        dropdownItemsClasses="!bg-transparent "
                                        dropdownOptions={[
                                            {
                                                label: "Pending",
                                                value: "pending",
                                            },
                                            {
                                                label: "In Progress",
                                                value: "in progress",
                                            },
                                            {
                                                label: "Completed",
                                                value: "completed",
                                            },
                                            {
                                                label: "Failed",
                                                value: "failed",
                                            },
                                            {
                                                label: "Attention Required",
                                                value: "attention required",
                                            },
                                        ]}
                                    />
                                </div>
                            </div>

                            <div>
                                {selectedView === "grid" ? (
                                    <GridView
                                        activeTasks={activeTasks}
                                        pendingTasks={pendingTasks}
                                        completedTasks={completedTasks}
                                        failedTasks={failedTasks}
                                        pagination={pagination}
                                        setUpdatedPage={setUpdatedPage}
                                        setLoadMore={setLoadMore}
                                        tasksTotal={tasksTotal}
                                    />
                                ) : (
                                    <ListView data={tasks} pagination={pagination} />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ModalContainer
                open={requestCustomAI}
                showCloseIcon={false}
                tailwindClassName="w-full w-[90%] sm:w-[553px] overflow-y-auto"
                closeModal={() => {
                    setRequestCustomAI(false);
                }}
            >
                <div className="bg-white shadow-cardShadow relative rounded-lg">
                    <div className="w-full md:flex md:justify-center ">
                        <div className="w-full md:w-[553px]">
                            <div className="w-full md:flex md:text-center items-center md:justify-center">
                                <div className="px-6 w-full flex py-4 border-b border-slate-200 text-center items-center justify-start relative">
                                    <span className="text-base font-rocGroteskMedium text-gm-50">
                                        Request Custom AI Agent
                                    </span>
                                    <div className="absolute right-[24px]">
                                        <i
                                            className="ri-close-fill text-2xl cursor-pointer"
                                            onClick={() => {
                                                setRequestCustomAI(false);
                                            }}
                                        ></i>
                                    </div>
                                </div>
                            </div>
                            <form
                                onSubmit={(e) => {
                                    handleSubmit(e);
                                }}
                                className="w-full"
                            >
                                <div className="space-y-4 p-6 max-h-[60vh] overflow-y-auto">
                                    <TextInput
                                        value={request?.name || ""}
                                        name={"name"}
                                        type={"text"}
                                        onChange={(e) => {
                                            setRequest({ ...request, name: e?.target?.value });
                                        }}
                                        placeholder={"Agent name (Optional)"}
                                        containerClassname=""
                                    />

                                    <TextareaInput
                                        name={"description"}
                                        value={request?.description || ""}
                                        onChange={(e) => {
                                            setRequest({
                                                ...request,
                                                description: e?.target?.value,
                                            });
                                        }}
                                        rows={3}
                                        placeholder={
                                            "What Should This Agent Do? (Core Functionality)"
                                        }
                                        required={true}
                                        floatingPlaceholderClass="!text-xs"
                                    />

                                    <MultiselectInput
                                        value={request?.agentData || []}
                                        name="agentData"
                                        placeholder={"What Data Should This Agent Use?"}
                                        handleChange={(name, value, valueArr) => {
                                            if (valueArr.includes("Other")) {
                                                setShowOtherInput(true);
                                            } else {
                                                setShowOtherInput(false);
                                            }
                                            setRequest((prev) => ({
                                                ...prev,
                                                [name]: valueArr,
                                            }));
                                        }}
                                        isRequired={false}
                                        dropdownOptions={[
                                            {
                                                label: "Sales data (DTC, Amazon, Retail, etc.)",
                                                value: "Sales data (DTC, Amazon, Retail, etc.)",
                                            },
                                            {
                                                label: "Inventory/warehouse data",
                                                value: "Inventory/warehouse data",
                                            },
                                            {
                                                label: "Purchase orders",
                                                value: "Purchase orders",
                                            },
                                            {
                                                label: "Supplier communications",
                                                value: "Supplier communications",
                                            },
                                            {
                                                label: "Marketing calendars",
                                                value: "Marketing calendars",
                                            },
                                            {
                                                label: "Retailer sell-through data",
                                                value: "Retailer sell-through data",
                                            },
                                            {
                                                label: "Custom CSV or Google Sheet",
                                                value: "Custom CSV or Google Sheet",
                                            },
                                            {
                                                label: "Other",
                                                value: "Other",
                                            },
                                        ]}
                                    />

                                    {showOtherInput && (
                                        <TextInput
                                            value={request?.other || ""}
                                            name={"other"}
                                            type={"text"}
                                            onChange={(e) => {
                                                setRequest((prev) => ({
                                                    ...prev,
                                                    other: e?.target?.value,
                                                }));
                                            }}
                                            placeholder={"Other"}
                                            containerClassname=""
                                        />
                                    )}

                                    <TextareaInput
                                        name={"agentOutputPurpose"}
                                        value={request?.agentOutputPurpose || ""}
                                        onChange={(e) => {
                                            setRequest((prev) => ({
                                                ...prev,
                                                agentOutputPurpose: e?.target?.value,
                                            }));
                                        }}
                                        rows={3}
                                        placeholder={"What Should This Agent Output or Automate?"}
                                        floatingPlaceholderClass="!text-xs"
                                    />
                                    <SelectInput
                                        value={request?.agentRunFrequency || ""}
                                        name="agentRunFrequency"
                                        placeholder={"When Should This Agent Run?"}
                                        handleChange={(name, value) => {
                                            // if (value === "Other") {
                                            //     setAgentRunFrequency(true);
                                            // }
                                            setRequest((prev) => ({
                                                ...prev,
                                                agentRunFrequency: value,
                                            }));
                                        }}
                                        dropdownOptions={[
                                            {
                                                label: "On a schedule (daily, weekly, etc.)",
                                                value: "On a schedule (daily, weekly, etc.)",
                                            },
                                            {
                                                label: "When triggered by a specific event (e.g., inventory drop, campaign launch)",
                                                value: "When triggered by a specific event (e.g., inventory drop, campaign launch)",
                                            },
                                            {
                                                label: "Manually by a user",
                                                value: "Manually by a user",
                                            },
                                            {
                                                label: "Other",
                                                value: "Other",
                                            },
                                        ]}
                                    />
                                    {/* {agentRunFrequency && (
                                        <TextInput
                                            value={agentRunFrequencyOther || ""}
                                            name={"Other"}
                                            type={"text"}
                                            onChange={(e) => {
                                                setAgentRunFrequencyOther(e?.target?.value);
                                            }}
                                            placeholder={"Other"}
                                            containerClassname=""
                                        />
                                    )} */}
                                    <MultiselectInput
                                        value={request?.agentUser || []}
                                        name="agentUser"
                                        placeholder={"Who Will Use This Agent?"}
                                        handleChange={(name, value, valueArr) => {
                                            setRequest((prev) => ({
                                                ...prev,
                                                [name]: valueArr,
                                            }));
                                        }}
                                        isRequired={false}
                                        dropdownOptions={[
                                            {
                                                label: "Operations",
                                                value: "Operations",
                                            },
                                            {
                                                label: "Supply Chain",
                                                value: "Supply Chain",
                                            },
                                            {
                                                label: "Finance",
                                                value: "Finance",
                                            },
                                            {
                                                label: "Marketing",
                                                value: "Marketing",
                                            },
                                            {
                                                label: "Founders/Execs",
                                                value: "Founders/Execs",
                                            },
                                            {
                                                label: "External partners (e.g., co-mans, suppliers)",
                                                value: "External partners (e.g., co-mans, suppliers)",
                                            },
                                        ]}
                                    />
                                    <SelectInput
                                        value={request?.agentPriority || ""}
                                        name="agentPriority"
                                        placeholder={"How Critical Is This Agent to You?"}
                                        handleChange={(name, value) => {
                                            setRequest((prev) => ({
                                                ...prev,
                                                [name]: value,
                                            }));
                                        }}
                                        dropdownOptions={[
                                            {
                                                label: "Must-have (blocking a key workflow)",
                                                value: "Must-have (blocking a key workflow)",
                                            },
                                            {
                                                label: "Important (would save significant time/money)",
                                                value: "Important (would save significant time/money)",
                                            },
                                            {
                                                label: "Nice-to-have",
                                                value: "Nice-to-have",
                                            },
                                        ]}
                                    />

                                    <TextareaInput
                                        name={"additionalNote"}
                                        value={request?.additionalNote || ""}
                                        onChange={(e) => {
                                            setRequest({
                                                ...request,
                                                additionalNote: e?.target?.value,
                                            });
                                        }}
                                        rows={3}
                                        placeholder={"Additional Notes or Context"}
                                        floatingPlaceholderClass="!text-xs"
                                    />
                                </div>

                                <div className="mt-1 py-4 px-6 border-t border-slate-200 flex items-center space-x-2 justify-end">
                                    <Button
                                        btnText={"Cancel"}
                                        onClick={() => {
                                            setRequestCustomAI(false);
                                        }}
                                        btnClassname={
                                            "!bg-tradeally-neutral-20 !text-gm-75 !w-fit "
                                        }
                                        disabled={creatingAgentRequest}
                                    />
                                    <Button
                                        btnText={"Submit Request"}
                                        isLoading={creatingAgentRequest}
                                        type={"submit"}
                                        btnClassname="!w-fit"
                                        btnTextClassName="!text-md"
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </ModalContainer>
        </div>
    );
};

export default NewDesign;
